"use client";

import type { RouteGeoData } from "@frend-digital/centra/middleware";
import { createContext, type PropsWithChildren, use } from "react";
import type { GlobalConfigStoryblok } from "@/generated/sb/sb-types";

interface GloablDataContext {
  userdata: RouteGeoData | null;
  globalData?: GlobalConfigStoryblok;
  preview: boolean;
}

export const GloablDataContext = createContext<GloablDataContext>(null!);

export const GlobalDataProvider = ({
  children,
  userdata,
  globalData,
  preview,
}: PropsWithChildren<{
  userdata: GloablDataContext["userdata"];
  globalData: GloablDataContext["globalData"];
  preview: GloablDataContext["preview"];
}>) => {
  return (
    <GloablDataContext.Provider
      value={{
        userdata,
        globalData,
        preview,
      }}
    >
      {children}
    </GloablDataContext.Provider>
  );
};

export const useGlobalData = () => {
  return use(GloablDataContext);
};
